import React, { useState, useEffect } from 'react';
import Fuse from 'fuse.js';
import './search-stocks.m.css';
import { widgetLink } from '../../../../../helpers/utils';
import { MaginifyIcon, CloseIcon } from '../../../../atoms/material-icons';

const SearchStocks = ({ widget }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [stocksData, setStocksData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [disclaimer, setDisclaimer] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location?.search);
    let utmCampaign = queryParams?.get('utm_campaign');
    if (!utmCampaign) {
      const getStocksListData = async () => {
        try {
          const stockDetailsResponse = await fetch('/next/feapi/stock/stock-details');
          const stockDetailsData = await stockDetailsResponse.json();
          setStocksData(stockDetailsData);
        } catch (error) {
          console.log('Error in searching stocks', error);
        }
      };
      getStocksListData();
    }
  }, []);

  const fuse = new Fuse(stocksData, {
    keys: ['COMPNAME'],
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 50,
    maxPatternLength: 32,
    minMatchCharLength: 2,
  });

  const onSearch = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (value && value.length >= 3) {
      setDisclaimer(false);
      const results =
        fuse &&
        fuse?._docs.filter(
          (item) =>
            item?.item?.COMPNAME?.toLowerCase().includes(value.toLowerCase()) ||
            item?.COMPNAME?.toLowerCase().includes(value.toLowerCase()),
        );
      setSearchResult(results);
    }
  };
  const suggestionSelected = (value) => {
    setSearchQuery(value?.COMPNAME);
    const stockId = value?.STOCKID;
    const stockName = value?.COMPNAME?.toLowerCase()
      .trim()
      .replaceAll(' ', '-')
      .split('-')
      .filter((val) => val !== '')
      .map((val) => val.replaceAll('.', ''))
      .join('-');
    window.open(widgetLink(`/stock/${stockId}/${stockName}${widgetParam}`, widget), '_blank');
  };

  const clearSearch = () => {
    setSearchQuery('');
    setSearchResult([]);
  };
  return (
    <div styleName="search-stocks">
      <input
        id="inputStock"
        placeholder="Search Stocks"
        list="stocks"
        value={searchQuery}
        onChange={(event) => onSearch(event)}
        onFocus={() => setDisclaimer(true)}
        onBlur={() => {
          setDisclaimer(false);
        }}
      />
      {disclaimer && (
        <ul styleName="disclaimer">
          <li>Type at least 3 characters</li>
        </ul>
      )}

      <ul styleName={searchQuery?.length >= 3 ? 'show' : 'hide'}>
        {searchResult?.length > 0 ? (
          searchResult?.map((item, index) => (
            <li key={index} onClick={() => suggestionSelected(item)}>
              {item?.item?.COMPNAME || item?.COMPNAME}
            </li>
          ))
        ) : (
          <li>No result found</li>
        )}
      </ul>

      <div styleName="search-icon">
        <MaginifyIcon />
      </div>
      {searchQuery.length > 0 && (
        <div styleName="close-icon" onClick={() => clearSearch()}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

export default SearchStocks;
